import Api from './Api'
export default {
    getEvents(obj) {
        if(obj){
            const {search, dateF, dateT, limit, page} = obj;

            let str = '';
            if(dateF){
                str+='date_from='+ dateF +'&';
            }
            if(dateT){
                str+='date_to='+dateT +'&';
            }
            if(search){
                str+='search='+search +'&';
            }
            if(limit){
                str+='limit='+limit +'&';
            }
            if(page){
                str+='page='+page +'&';
            }


            return Api().get('/event/index?'+str)
        }else {
            return Api().get('/event/index')
        }
    },
}